import axios from 'axios';
import config from '../../app/config';
import QS from '../../app/utils/query-string';

export function getTsaTrialPeriodList() {
  return axios({
    method: 'get',
    url: `${config.getApiDomain()}/admin/tsa-trial-periods`,
  });
}

export function getTsaTrialPeriod(id) {
  return axios({
    method: 'get',
    url: `${config.getApiDomain()}/admin/tsa-trial-period`,
    params: { id },
  });
}

export function saveTsaTrialPeriod(data) {
  return axios({
    method: 'post',
    url: `${config.getApiDomain()}/admin/save-tsa-trial-period`,
    data: QS.stringify(data),
  });
}

export function getTsaTrialRegistrations(periodId, page = 1, pageSize = 20) {
  return axios({
    method: 'get',
    url: `${config.getApiDomain()}/admin/tsa-trial-registrations`,
    params: { period_id: periodId, page, page_size: pageSize },
  });
}

export function exportTsaTrialRegistrations(periodId) {
  return axios({
    method: 'get',
    url: `${config.getApiDomain()}/admin/export-tsa-trial-registrations`,
    params: { period_id: periodId },
    responseType: 'blob',
  });
}
